import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ChangeLog } from '@via/models';
import { CommonService } from '@via/services';
import { GridComponent, GridCustomOptions } from '@via/standalone';
import { ColDef, ValueGetterParams } from 'ag-grid-community';

@Component({
  selector: 'via-change-logs',
  standalone: true,
  imports: [GridComponent],
  templateUrl: './change-logs.component.html',
})
export class ChangeLogsComponent {
  @Input() set rowData(value: ChangeLog[]) {
    this.changeLogTableData = value;
  }
  changeLogTableColumns: ColDef[] = [
    { headerName: 'Change', field: 'fieldName', maxWidth: 200 },
    {
      headerName: 'Changed Date',
      field: 'updatedDate',
      maxWidth: 200,
      filter: 'agDateColumnFilter',
      valueGetter: (params: ValueGetterParams<ChangeLog>) =>
        this.datePipe.transform(
          params.data?.updatedDate,
          'MM/dd/yyyy hh:mm a'
        ) as string,
      filterParams: {
        comparator: (filterLocalDateAtMidnight: Date, cellValue: string) =>
          this.commonService.gridDateComparator(
            filterLocalDateAtMidnight,
            cellValue
          ),
      },
    },
    {
      headerName: 'Changed By',
      field: 'updatedBy',
      maxWidth: 200,
      valueGetter: (params: ValueGetterParams<ChangeLog>) =>
        params.data?.updatedBy || '-',
    },
    {
      field: 'description',
      wrapText: true,
      autoHeight: true,
    },
  ];
  gridCustomOptions: GridCustomOptions = {
    showTextSearch: true,
    showActions: false,
    floatingFilterHide: false,
  };
  changeLogTableData: ChangeLog[] = [];

  constructor(
    private datePipe: DatePipe,
    private commonService: CommonService
  ) {}
}
